import { render, staticRenderFns } from "./DxMonthlyComponent.vue?vue&type=template&id=256c63d6&scoped=true&"
import script from "./DxMonthlyComponent.vue?vue&type=script&lang=js&"
export * from "./DxMonthlyComponent.vue?vue&type=script&lang=js&"
import style0 from "./DxMonthlyComponent.vue?vue&type=style&index=0&id=256c63d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c63d6",
  null
  
)

export default component.exports